module.exports = __webpack_public_path__ + "images/95f423bc630a18f3e893fb87e394fea34406b5977728832310b5e75b2ba58263.svg";